import { useEffect, useState } from "react";
import api from '../../apis';

const SelectInput = ({ label,id,onValueChange }:any) => {
    const [options, setOptions] = useState<any>([]);
    useEffect(() => {
        requestAnnoucementType();
    }, []);

     const requestAnnoucementType = () => {
        return api.getBroadcastType().then((result: any) => {
            if (result) {
                //convert result tp label value pair
                
            let data = Object.keys(result).map((key) => {
                return {
                    label: result[key],
                    value: key
                }
            });
                //add all value to first
                data.unshift({label:"All",value:""});
                setOptions(data);
            }

            // setTreeSelectLoading(false);
            // if (result.clients) updateTreeSelect(result.clients);
        });
    };

    return (
        <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
            {' '}
            <div className="input-container ">
                <div className="label"> Annoucement Type </div>
                <select className="custom" defaultValue={''}
                    onChange={(e) => onValueChange("type    ",e.target.value)}
                >
                    {
                        options.map((option:any,i:any) => {
                            return (
                                <option key={i} value={option.value}>
                                    {option.label}
                                </option>
                            );
                        })
                    }
                 
                </select>
            </div>
        </div>
    );
}

export default SelectInput;